import React from "react";
import PropTypes from "prop-types";
import AppTableContainer from "../../../../@crema/core/AppTableContainer";
import ProfessionalProfileTableActions from "./ProfessionalProfileTableActions";

function ProfessionalProfileTable({
  professionalProfile,
  loading,
  handleSortChange,
}) {
  const columns = [
    {
      title: "Name",
      dataIndex: "professionalProfileName",
      key: "professionalProfileName",
      defaultSortOrder: "descend",
      sorter: () => {},
    },
    {
      title: "Created At",
      dataIndex: "updatedAtFormatted",
      key: "updatedAtFormatted",
      defaultSortOrder: "descend",
      sorter: () => {},
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      className: "customer-table-actions",
      fixed: "right",
      render: (_, record) => {
        return <ProfessionalProfileTableActions data={record} />;
      },
    },
  ];
  return (
    <AppTableContainer
      className="customer-table"
      hoverColor
      data={professionalProfile}
      columns={columns}
      scroll={{ x: "auto" }}
      onChange={handleSortChange}
    />
  );
}
export default ProfessionalProfileTable;

ProfessionalProfileTable.defaultProps = {
  professionalProfile: [],
};

ProfessionalProfileTable.propTypes = {
  professionalProfile: PropTypes.array,
  loading: PropTypes.bool,
};
